/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Registration, RegistrationInterface } from "../Registration";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IMX",
        name: "_imx",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "imx",
    outputs: [
      {
        internalType: "contract IMX",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
    ],
    name: "isRegistered",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ethKey",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "assetType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "vaultId",
        type: "uint256",
      },
    ],
    name: "registerAndDeposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ethKey",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "assetType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "vaultId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quantizedAmount",
        type: "uint256",
      },
    ],
    name: "registerAndDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ethKey",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "assetType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "vaultId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "registerAndDepositNft",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ethKey",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "assetType",
        type: "uint256",
      },
    ],
    name: "registerAndWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ethKey",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "assetType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "registerAndWithdrawNft",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ethKey",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "assetType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "registerAndWithdrawNftTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ethKey",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "assetType",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "registerAndWithdrawTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ethKey",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "starkKey",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "assetType",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "mintingBlob",
        type: "bytes",
      },
    ],
    name: "regsiterAndWithdrawAndMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Registration__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _imx: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Registration> {
    return super.deploy(_imx, overrides || {}) as Promise<Registration>;
  }
  getDeployTransaction(
    _imx: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_imx, overrides || {});
  }
  attach(address: string): Registration {
    return super.attach(address) as Registration;
  }
  connect(signer: Signer): Registration__factory {
    return super.connect(signer) as Registration__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RegistrationInterface {
    return new utils.Interface(_abi) as RegistrationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Registration {
    return new Contract(address, _abi, signerOrProvider) as Registration;
  }
}
